/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Visit } from '../models/Visit';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisitsService {
    /**
     * Get Visits
     * Get all visits. Optionally filter by patient_id.
     * @returns Visit Successful Response
     * @throws ApiError
     */
    public static getVisitsApiVisitsGet({
        patientId,
    }: {
        patientId?: number,
    }): CancelablePromise<Array<Visit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/visits/',
            query: {
                'patient_id': patientId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Visit
     * Create a new visit.
     * @returns Visit Successful Response
     * @throws ApiError
     */
    public static createVisitApiVisitsPost({
        requestBody,
    }: {
        requestBody: Visit,
    }): CancelablePromise<Visit> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/visits/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Visit
     * Get a single visit by ID.
     * @returns Visit Successful Response
     * @throws ApiError
     */
    public static getVisitApiVisitsVisitIdGet({
        visitId,
    }: {
        visitId: number,
    }): CancelablePromise<Visit> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/visits/{visit_id}',
            path: {
                'visit_id': visitId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Visit
     * Update an existing visit.
     * @returns Visit Successful Response
     * @throws ApiError
     */
    public static updateVisitApiVisitsVisitIdPut({
        visitId,
        requestBody,
    }: {
        visitId: number,
        requestBody: Visit,
    }): CancelablePromise<Visit> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/visits/{visit_id}',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Visit
     * Delete a visit.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteVisitApiVisitsVisitIdDelete({
        visitId,
    }: {
        visitId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/visits/{visit_id}',
            path: {
                'visit_id': visitId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
